// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

export const UPDATE = "mondoo.integrations.IntegrationsManager.Update";
